/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Operations for LoadCarrier
 */
export enum LoadCarrierOperation {
  Adoption = 'adoption',
  Delivery = 'delivery'
}
